'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DESearchHeader = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _glamor = require('glamor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _core = require('@blueprintjs/core');

var _ = require('../../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = _glamorous2.default.div({
  display: 'flex',
  backgroundColor: _.Colors.BLUE2,
  alignItems: 'center',
  justifyContent: 'space-between',
  minHeight: 60
}, function (_ref) {
  var isRtl = _ref.isRtl,
      noPadding = _ref.noPadding;
  return {
    flexDirection: isRtl ? 'row-reverse' : 'row',
    padding: noPadding ? 0 : '0 ' + _.Layout.PADDING
  };
});

var Logo = _glamorous2.default.img({
  maxWidth: 300,
  maxHeight: 48
});

var StyledRadioGroup = (0, _glamorous2.default)(_core.RadioGroup)({
  display: 'flex',
  flexWrap: 'wrap'
}, function (_ref2) {
  var isRtl = _ref2.isRtl;
  return {
    justifyContent: isRtl ? 'flex-start' : 'flex-end'
  };
});

var SearchInputWrapper = _glamorous2.default.div({
  minWidth: 200,
  width: 300
});

var blueprintOverrides = (0, _glamor.css)({
  '.pt-control input:checked ~ .pt-control-indicator': {
    backgroundColor: _.Colors.GREEN1
  },
  '.pt-control': {
    margin: '0 20px',
    color: _.Colors.WHITE1
  }
});

var DESearchHeader = exports.DESearchHeader = function DESearchHeader(_ref3) {
  var isRtl = _ref3.isRtl,
      isNarrow = _ref3.isNarrow,
      logo = _ref3.logo,
      term = _ref3.term,
      changeSearch = _ref3.changeSearch,
      searchPageLabel = _ref3.searchPageLabel,
      searchDELabel = _ref3.searchDELabel,
      onlyLogo = _ref3.onlyLogo;
  return _react2.default.createElement(
    Wrapper,
    { isRtl: isRtl },
    _react2.default.createElement(Logo, { src: logo, alt: 'logo' }),
    onlyLogo || isNarrow ? null : _react2.default.createElement(
      Wrapper,
      { noPadding: true, isRtl: isRtl },
      _react2.default.createElement(
        SearchInputWrapper,
        null,
        _react2.default.createElement(_.DESearchInput, { term: term, changeSearch: changeSearch, isRtl: isRtl })
      )
    )
  );
};

DESearchHeader.propTypes = {
  isRtl: _propTypes2.default.bool,
  isNarrow: _propTypes2.default.bool,
  onlyLogo: _propTypes2.default.bool,
  logo: _propTypes2.default.string,
  term: _propTypes2.default.string,
  changeSearch: _propTypes2.default.func.isRequired,
  searchDELabel: _propTypes2.default.element,
  searchPageLabel: _propTypes2.default.element
};


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/de-search-header/index.js
// module id = 2021
// module chunks = 0